module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab104-ab89e40d53ee0b0489a22808e2811fe2.jpg";